import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { compose } from 'recompose';
import moment from 'moment';
import ReactHtmlParser from 'react-html-parser';

import { DateFormat } from '../../../../../../../../utils/date';
import { SubTitle, ModalContent } from '../../styles';

import {
  EmptyState,
  StyledDate,
  StyledDescription,
  StyledCard,
} from './styles';
import texts from './texts.json';

const Promotions = ({
  activePromotions,
}) => (
  <ModalContent>
    <SubTitle>
      {texts.title}
    </SubTitle>
    {activePromotions.length > 0 ? (
      activePromotions.map((promotion) => (
        <StyledCard key={promotion.id}>
          <StyledDate>
            {`${moment(promotion.startDate).format(DateFormat.DATE_FORMAT_COMMA)} - ${
              moment(promotion.endDate).format(DateFormat.DATE_FORMAT_COMMA)
            }`}
          </StyledDate>
          <StyledDescription>
            {ReactHtmlParser(promotion.description)}
          </StyledDescription>
        </StyledCard>
      ))
    ) : (
      <EmptyState>
        {texts.noPromotions}
      </EmptyState>
    )}
  </ModalContent>
);

Promotions.propTypes = {
  activePromotions: PropTypes.arrayOf(PropTypes.object),
};

Promotions.defaultProps = {
  activePromotions: [],
};

export default compose(
  observer,
)(Promotions);
